import {useState} from 'react';

import {TypographyVariantsEnum} from '../../../utils/_enums/typeography-variants.enum';
import {Typography} from '../typography/typography';
import styles from './toggle-bar.module.scss';

interface ToggleBarProps {
    onToggleLeft: () => void;
    onToggleRight: () => void;
    leftHeadline: string;
    rightHeadline: string;
}

const ToggleBar = (props: ToggleBarProps) => {
    const [leftActive, setLeftActive] = useState<boolean>(true);

    return (
        <div className={styles['toggle-bar']}>
            <div className={leftActive ? styles['toggle-bar-left-wrapper-active'] : styles['toggle-bar-left-wrapper']}>
                <div className={leftActive ? styles['toggle-bar-left-active'] : styles['toggle-bar-left']}
                     onClick={() => {
                         if (!leftActive) {
                             setLeftActive(true);
                             props.onToggleLeft();
                         }
                     }}>
                    <Typography variant={leftActive ? TypographyVariantsEnum.HEADING5 : TypographyVariantsEnum.BODY}>
                        {props.leftHeadline}
                    </Typography>
                </div>
            </div>
            <div
                className={leftActive ? styles['toggle-bar-right-wrapper'] : styles['toggle-bar-right-wrapper-active']}>
                <div className={leftActive ? styles['toggle-bar-right'] : styles['toggle-bar-right-active']}
                     onClick={() => {
                         if (leftActive) {
                             setLeftActive(false);
                             props.onToggleRight();
                         }
                     }}>
                    <Typography variant={!leftActive ? TypographyVariantsEnum.HEADING5 : TypographyVariantsEnum.BODY}>
                        {props.rightHeadline}
                    </Typography>
                </div>
            </div>
            <div className={styles['empty-line']}>

            </div>
        </div>
    );
}

export default ToggleBar;
